import { render, staticRenderFns } from "./notification-in-bell.vue?vue&type=template&id=668746db"
import script from "./notification-in-bell.vue?vue&type=script&lang=js"
export * from "./notification-in-bell.vue?vue&type=script&lang=js"
import style0 from "./notification-in-bell.vue?vue&type=style&index=0&id=668746db&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports